module.exports = __webpack_public_path__ + "img/essay-db-active.10206570.png";